module.exports = __webpack_public_path__ + "img/win3.b54430e5.png";